// extracted by mini-css-extract-plugin
export default {"SearchContainer":"Search-module__SearchContainer--bKqAd"};